import { request } from './client.js';

export const pipelineApi = {
  start: (start, end) =>
    request('/api/pipeline/start', {
      method: 'POST',
      body: JSON.stringify({ start_date: start, end_date: end }),
    }),
  startNsSync: () => request('/api/pipeline/start-ns-sync', { method: 'POST' }),
  getStatus: (runId) => request(`/api/pipeline/status/${runId}`),
  getRuns: () => request('/api/pipeline/runs'),

  // What's running right now: in-memory pipeline, in-flight reprocess, or
  // a scheduled extraction batch. Returns ``{conflict: {...} | null}``.
  // Polled while idle so the four buttons disable automatically when a
  // cron job kicks off, and used on mount to hydrate progress panels
  // after a page reload that happened mid-run.
  getActive: () => request('/api/pipeline/active'),

  // Manual Reprocess Billing. The backend returns immediately with a
  // ``run_id`` and fires the long-running function call on a background
  // thread — the UI polls the status endpoint until terminal. This
  // works around Azure Front Door's 230-second idle-timeout on HTTP.
  // ``runMode: 'quick'`` rebuilds only the (employee, week) units whose
  // Dayforce source data changed since the last successful reprocess.
  reprocessBilling: ({ force = false, runMode = 'full' } = {}) =>
    request('/api/pipeline/reprocess-billing', {
      method: 'POST',
      body: JSON.stringify({ force: Boolean(force), run_mode: runMode }),
    }),
  getReprocessStatus: (runId) =>
    request(`/api/pipeline/reprocess-status/${encodeURIComponent(runId)}`),
};
